import { CCol, CContainer, CRow } from '@coreui/react';
import React from 'react';
import { ERROR_404_DESCRIPTION, ERROR_404_SUBTITLE, ERROR_404_TITLE } from './constant/text';

const NotFound = () => {
	return (
		<div className="c-app c-default-layout flex-row align-items-center">
			<CContainer>
				<CRow className="justify-content-center">
					<CCol md="6">
						<div className="clearfix">
							<h1 className="float-left display-3 mr-4">{ERROR_404_TITLE}</h1>
							<h4 className="pt-3">{ERROR_404_SUBTITLE}</h4>
							<p className="text-muted float-left">{ERROR_404_DESCRIPTION}</p>
						</div>
					</CCol>
				</CRow>
			</CContainer>
		</div>
	);
};

export default NotFound;
